import React, { useState, useEffect } from 'react';
import { GridView, CrudMasterDetailView, CompositeView, CrudContext } from '@digital/ui';
import { getAllOrcadoAnoNaoPrevisto } from '@app/api/naoPrevistos/parametros';
import AbaResumo from './AbaResumo';
import AbaNaoPrevisto from './AbaNaoPrevisto';
import AbaDoacoes from './AbaDoacoes';

const Controle = () => {
    const [orcadoAnos, setOrcadoAnos] = useState(() => getAllOrcadoAnoNaoPrevisto);

    useEffect(() => {
        setOrcadoAnos(() => Promise.resolve(undefined));
        setOrcadoAnos(() => getAllOrcadoAnoNaoPrevisto);
    });

    return (
        <CrudMasterDetailView
            getAllItems={orcadoAnos}
            disableNotification
            icon='business-process'
            detailTitleExtractor={item => `${item.ano}`}
            filterPredicate={(item, value) =>
                item.ano !== undefined &&
                item.ano.toString().includes(value.toLowerCase())
            }
            titleExtractor={item => `${item.ano}`}
            descriptionExtractor={_item => ''}
        >
            <CrudContext.Consumer>
                {({ selectedItem }) => {
                    if (!selectedItem?.ano) return <></>;

                    return (
                        <CompositeView>
                            <GridView noform id="resumo" title="Resumo" icon='business-resume'>
                                <AbaResumo ano={selectedItem.ano} />
                            </GridView>

                            <GridView noform id="nao-previsto" title="Não Previsto" icon='science-idea_sharing'>
                                <AbaNaoPrevisto ano={selectedItem.ano} />
                            </GridView>

                            <GridView noform id="doadores" title="Doadores" icon='commons-share'>
                                <AbaDoacoes ano={selectedItem.ano} />
                            </GridView>
                        </CompositeView>
                    );
                }}
            </CrudContext.Consumer>
        </CrudMasterDetailView>
    );
}

export default Controle;